module.exports = __webpack_public_path__ + "1793882494189/fonts/WorkSans-Light.af064db.woff2";